import iconFB from '../images/icons/icon_social_fb.png';
import iconIG from '../images/icons/icon_social_insta.png';
import iconYT from '../images/icons/icon_social_youtube.png';
import iconTW from '../images/icons/icon_social_tw.png';
import iconGreyFB from '../images/icons/grey_FB.png';
import iconGreyTW from '../images/icons/grey_TW.png';
import iconGreyYT from '../images/icons/grey_YT.png';
import iconGreyIG from '../images/icons/grey_IG.png';
import iconFBAlt from '../images/icons/icon_social_fb_color.png';
import iconIGAlt from '../images/icons/icon_social_insta_color.png';
import iconYTAlt from '../images/icons/icon_social_yt_color.png';
import iconTWAlt from '../images/icons/icon_social_tw_color.png';
import iconFBAltYellow from '../images/icons/icon_social_fb_yellow.png';
import iconIGAltYellow from '../images/icons/icon_social_insta_yellow.png';
import iconYTAltYellow from '../images/icons/icon_social_yt_yellow.png';
import iconNewFB from '../images/icons/fbSocial.png';
import iconNewIG from '../images/icons/igSocial.png';
import iconNewYT from '../images/icons/ytSocial.png';
import iconNewTW from '../images/icons/xSocial.png';
import iconNewTK from '../images/icons/tkSocial.png';
import iconNewFBReverse from '../images/icons/fbSocialReverse.png';
import iconNewIGReverse from '../images/icons/igSocialReverse.png';
import iconNewYTReverse from '../images/icons/ytSocialReverse.png';
import iconNewTWReverse from '../images/icons/xSocialReverse.png';
import iconNewTKReverse from '../images/icons/tkSocialReverse.png';
export const HEADER_LINKS = [
  {
    name: 'home',
    url: '/'
  },
  // {
  //   name: 'everestMilestone',
  //   url: '/everest'
  // },
  {
    name: 'ourStory',
    url: '/our-story'
  },
  {
    name: 'help',
    url: '/help-and-support'
  },
  {
    name: 'faq',
    url: '/faq'
  },
  // {
  //   name: 'demo',
  //   url: '/demo'
  // }
];

export const HEADER_CONTEST_LINKS = [
  {
    name: 'home',
    url: '/'
  },
  {
    name: 'ourStory',
    url: '/our-story'
  }
];

export const HEADER_AUTH_LINKS = [
  {
    name: 'signUp',
    url: '/signup',
    method: 'signup'
  },
  {
    name: 'login',
    url: '/login',
    method: 'login'
  }
];

export const HEADER_MOBILE_LINKS = [
  {
    name: 'home',
    url: '/'
  },
  // {
  //   name: 'everestMilestone',
  //   url: '/everest'
  // },
  {
    name: 'ourStory',
    url: '/our-story'
  },
  {
    name: 'help',
    url: '/help-and-support'
  },
  {
    name: 'faq',
    url: '/faq'
  },
  {
    name: 'tnc',
    url: '/terms-and-conditions'
  },
  {
    name: 'privacyDisclaimer',
    url: '/privacy-disclaimer'
  }
];

export const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    icon: iconNewFB,
    iconAlt: iconNewFBReverse,
    iconYellow: iconFBAltYellow,
    url: 'https://www.facebook.com/FordMalaysia/'
  },
  {
    name: 'Instagram',
    icon: iconNewIG,
    iconAlt: iconNewIGReverse,
    iconYellow: iconIGAltYellow,
    url: 'https://www.instagram.com/fordmalaysia/'
  },
  {
    name: 'YouTube',
    icon: iconNewYT,
    iconAlt: iconNewYTReverse,
    iconYellow: iconYTAltYellow,
    url: 'https://www.youtube.com/user/FordMsia'
  },
  {
    name: 'Twitter',
    icon: iconNewTW,
    iconAlt: iconNewTWReverse,
    // iconYellow: iconYTAltYellow,
    url: 'https://twitter.com/ford_malaysia'
  },
  {
    name: 'Tiktok',
    icon: iconNewTK,
    iconAlt: iconNewTKReverse,
    url: 'https://www.tiktok.com/@ford_malaysia'
  }
];

export const SOCIAL_LINKS_EVEREST = [
  {
    name: 'Facebook',
    icon: iconGreyFB,
    iconAlt: iconGreyFB,
    iconYellow: iconFBAltYellow,
    url: 'https://www.facebook.com/FordMalaysia/'
  },
  {
    name: 'Instagram',
    icon: iconGreyIG,
    iconAlt: iconGreyIG,
    iconYellow: iconIGAltYellow,
    url: 'https://www.instagram.com/fordmalaysia/'
  },
  {
    name: 'YouTube',
    icon: iconGreyYT,
    iconAlt: iconGreyYT,
    iconYellow: iconYTAltYellow,
    url: 'https://www.youtube.com/user/FordMsia'
  },
  {
    name: 'Twitter',
    icon: iconGreyTW,
    iconAlt: iconGreyTW,
    // iconYellow: iconYTAltYellow,
    url: 'https://twitter.com/ford_malaysia'
  }
];

export const FOOTER_LINKS = [
  {
    name: 'home',
    url: '/'
  },
  {
    name: 'ourStory',
    url: '/our-story'
  },
  {
    name: 'help',
    url: '/help-and-support'
  },
  {
    name: 'faq',
    url: '/faq'
  },
  {
    name: 'tnc',
    url: '/terms-and-conditions'
  },
  {
    name: 'privacyDisclaimer',
    url: '/privacy-disclaimer'
  }
];
